// prettier-ignore

import { makeStyles } from "@material-ui/styles";
import React from "react";
import { Route, Router, Routes, BrowserRouter } from "react-router-dom";
import { history } from "./configureStore";
import PhotoUploader from "./uploadphoto/PhotoUploader";
import NotFound from "./uploadphoto/NotFound";
import { withRoot } from "./withRoot";
import { UrlResolver } from "./util/UrlResolver";
import VersionInfo from "./VersionInfo";
import { datadogRum } from '@datadog/browser-rum';
import { DatadogResolver } from './util/DatadogResolver';
import packageInfo from '../package.json';

function App() {
  const classes = useStyles();
  const env = UrlResolver.getEnvironment();

  console.log(`CCC-Photo-Upload Version: ${packageInfo.version} Env: ${env}`);
  datadogRum.init(DatadogResolver.resolveConfig(env, packageInfo.version));

  React.useEffect(() => {
    // Log the version in the console
    console.log(`Version: ${packageInfo.version}`);
    console.log(`Build: ${process.env.REACT_APP_BUILD_NUMBER}`);
  }, []);
  sessionStorage.setItem("env", env);

  return (
    <BrowserRouter>
      <div className={classes.root}>
        <style>
          @import
          url('https://fonts.googleapis.com/css2?family=Oswald:wght@300;400&display=swap');
        </style>
        <div className={classes.appFrame}>
          <div data-iframe-height className={classes.content}>
            <Routes>
              <Route path="/uploadPhotos" element={<PhotoUploader />} />
              <Route path="*" element={<NotFound></NotFound>} />
            </Routes>
          </div>
        </div>
      </div>
      <VersionInfo />
    </BrowserRouter>
  );
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    width: "100%",
    height: "100%",
    zIndex: 1,
    overflow: "hidden",
    backgroundColor: theme.custom.colors.secondaryColor,
  },
  appFrame: {
    width: "100%",
    height: "100%",
  },
  content: {
    width: "98%",
    height: "100%",
    margin: "auto",
    backgroundColor: theme.custom.colors.secondaryColor,
    [theme.breakpoints.up("xs")]: {
      height: "95%",
    },
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  card: {
    width: "100%",
    height: "100%",
    zIndex: 1,
    overflow: "hidden",
    backgroundColor: theme.custom.colors.secondaryColor,
  },
}));

export default withRoot(App);
